/** @format */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { IconModule } from '@visurel/iconify-angular';
import { ScrollbarModule } from '../../components/scrollbar/scrollbar.module';
import { SidenavItemModule } from './sidenav-item/sidenav-item.module';
import { SidenavComponent } from './sidenav.component';

@NgModule({
  declarations: [SidenavComponent],
  imports: [
    CommonModule,
    IconModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    ScrollbarModule,
    SidenavItemModule,
  ],
  exports: [SidenavComponent],
})
export class SidenavModule {}
